/** Period pickers feed the report endpoints a plain inclusive ISO range. */

export interface PeriodLike {
  year: number;
  month: number;
}

export interface DateRange {
  from: string;
  to: string;
}

function iso(year: number, month: number, day: number): string {
  return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export function monthRange(year: number, month: number): DateRange {
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
  return { from: iso(year, month, 1), to: iso(year, month, lastDay) };
}

export function periodRange(period: PeriodLike): DateRange {
  return monthRange(period.year, period.month);
}

export function reportQuery(params: Record<string, string | undefined>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== '') {
      search.set(key, value);
    }
  }
  return search.toString();
}

/** 1-based month names come from the active catalog so the label follows the language. */
export function periodLabel(period: PeriodLike, monthNames: readonly string[]): string {
  return `${monthNames[period.month - 1] ?? String(period.month)} ${period.year}`;
}

export function reportMonth(isoDate: string): { year: number; month: number } | null {
  const match = /^(\d{4})-(\d{2})/u.exec(isoDate);
  if (match === null) {
    return null;
  }
  return { year: Number(match[1]), month: Number(match[2]) };
}
